import { themes as tamaguiThemes } from "@tamagui/themes";

import { tokens } from "./tokens";

export const themes = {
  ...tamaguiThemes,
  dark: {
    ...tamaguiThemes.dark,
    background: "#161616",
    color: "#FFFFFF",
  },
  light: {
    ...tamaguiThemes.light,
    background: "#FFFFFF",
    color: "#000000",
  },
  waterCard: {
    background: tokens.color.cardBackground,
    color: tokens.color.textLight,
  },
  hvacCard: {
    background: tokens.color.cardBackground,
    color: tokens.color.textLight,
  },
  airQualityCard: {
    background: tokens.color.cardBackground,
    color: tokens.color.textLight,
  },
  energyCard: {
    background: tokens.color.cardBackground,
    color: tokens.color.textLight,
  },
};
